import { Link } from 'react-router-dom';
import { comics, mascotUrls } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative min-h-[100vh] flex items-center overflow-hidden bg-white">
      {/* 网点背景装饰 */}
      <div className="absolute top-0 left-0 w-[440px] h-[440px] halftone-pink pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[360px] h-[360px] halftone-dark pointer-events-none" />

      {/* 顶部速度线 */}
      <div className="absolute top-10 left-1/2 -translate-x-1/2 hidden md:flex gap-2 pointer-events-none">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <span
            key={i}
            className="w-px bg-pink-200/70"
            style={{ height: `${70 + i * 22}px`, transform: `rotate(${(i - 2.5) * 7}deg)` }}
          />
        ))}
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 xl:px-24 pt-24 pb-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* 左侧文案 */}
          <div className="text-center lg:text-left">
            {/* 对话气泡式标签 */}
            <div className="flex justify-center lg:justify-start mb-8">
              <div className="relative">
                <span className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-white border-2 border-gray-900 text-xs font-bold tracking-wider text-gray-900 shadow-[4px_4px_0_0_#ff9db8]">
                  <i className="ri-flashlight-line text-pink-500" />
                  天天漫画 · 官方正版 · 每日更新
                </span>
                <span className="absolute -bottom-2 left-8 w-3 h-3 bg-white border-b-2 border-r-2 border-gray-900 rotate-45" />
              </div>
            </div>

            <h1 className="relative inline-block font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-[1.15] tracking-tight">
              天天漫画
              <span className="absolute -bottom-2 left-0 right-0 h-3 bg-pink-200/80 -rotate-1 rounded-full" />
            </h1>
            <p className="mt-5 font-serif text-xl md:text-2xl text-gray-500 font-light">
              用最简单的线条，读最丰富的故事
            </p>

            <p className="mt-7 text-base md:text-lg text-gray-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              海量热门漫画，每日更新不断档。天天漫画APP下载即刻开启阅读之旅，安全可靠，让好故事常伴左右。
            </p>

            <div className="mt-9 flex flex-col items-center lg:items-start gap-5">
              <Link to="/download" className="btn-comic-solid text-base px-10 py-4">
                <i className="ri-download-2-line text-lg" />
                立即下载
              </Link>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-2 text-sm text-gray-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-pink-500" /> 官方正版
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-vip-crown-line text-pink-500" /> 免费使用
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-refresh-line text-pink-500" /> 每日更新
                </span>
              </div>
            </div>
          </div>

          {/* 右侧 — 站娘漫画面板框 */}
          <div className="flex justify-center items-center relative h-[340px] md:h-[480px] lg:h-[620px]">
            {/* 浮动漫画卡片 1 — 仅桌面 */}
            <div className="hidden lg:block absolute top-12 left-4 w-24 h-32 rounded-lg overflow-hidden border-2 border-gray-900 shadow-[4px_4px_0_0_#ff9db8] animate-float z-20 bg-white">
              <img src={comics[0].cover} alt="" className="w-full h-full object-cover" />
            </div>
            {/* 浮动漫画卡片 2 — 仅桌面 */}
            <div className="hidden lg:block absolute bottom-16 right-2 w-24 h-32 rounded-lg overflow-hidden border-2 border-gray-900 shadow-[4px_4px_0_0_#1a1a1a] animate-float-delay z-20 bg-white">
              <img src={comics[2].cover} alt="" className="w-full h-full object-cover" />
            </div>

            {/* 漫画面板框 */}
            <div className="relative rounded-lg border-2 border-gray-900 bg-gradient-to-b from-pink-50 to-white shadow-[8px_8px_0_0_#ff9db8] overflow-hidden">
              <div className="absolute top-3 right-3 w-16 h-16 halftone-pink pointer-events-none" />
              <img
                src={mascotUrls.hero}
                alt="天天漫画站娘"
                className="relative z-0 h-[280px] md:h-[400px] lg:h-[520px] w-auto object-contain"
              />
            </div>

            {/* 装饰角标 — 仅桌面 */}
            <div className="hidden lg:block absolute -top-3 -right-3 w-12 h-12 rounded-lg border-2 border-gray-900 bg-white flex items-center justify-center shadow-[3px_3px_0_0_#ff9db8] z-30">
              <i className="ri-heart-3-fill text-lg text-pink-500" />
            </div>
          </div>
        </div>
      </div>

      {/* 底部滚动提示 */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-300">
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <i className="ri-arrow-down-line animate-bounce" />
      </div>
    </section>
  );
}